export const localities = [
    { label: 'Buenos Aires - Lincoln', value: 'Buenos Aires - Lincoln' },
    { label: 'Buenos Aires - La Plata', value: 'Buenos Aires - La Plata' },
    { label: 'Buenos Aires - Mar del Plata', value: 'Buenos Aires - Mar del Plata' },
    { label: 'Buenos Aires - Bahía Blanca', value: 'Buenos Aires - Bahía Blanca' },
    { label: 'Buenos Aires - Tandil', value: 'Buenos Aires - Tandil' },
    { label: 'Buenos Aires - San Nicolás', value: 'Buenos Aires - San Nicolás' },
    { label: 'Buenos Aires - Pergamino', value: 'Buenos Aires - Pergamino' },
    { label: 'Buenos Aires - Junín', value: 'Buenos Aires - Junín' },
    { label: 'Buenos Aires - Chivilcoy', value: 'Buenos Aires - Chivilcoy' },
    { label: 'Buenos Aires - Mercedes', value: 'Buenos Aires - Mercedes' },
    { label: 'Córdoba - Córdoba', value: 'Córdoba - Córdoba' },
    { label: 'Córdoba - Río Cuarto', value: 'Córdoba - Río Cuarto' },
    { label: 'Córdoba - Villa María', value: 'Córdoba - Villa María' },
    { label: 'Córdoba - San Francisco', value: 'Córdoba - San Francisco' },
    { label: 'Córdoba - Villa Carlos Paz', value: 'Córdoba - Villa Carlos Paz' },
    { label: 'Córdoba - Alta Gracia', value: 'Córdoba - Alta Gracia' },
    { label: 'Córdoba - Bell Ville', value: 'Córdoba - Bell Ville' },
    { label: 'Córdoba - Jesús María', value: 'Córdoba - Jesús María' },
    { label: 'Santa Fe - Rosario', value: 'Santa Fe - Rosario' },
    { label: 'Santa Fe - Santa Fe', value: 'Santa Fe - Santa Fe' },
    { label: 'Santa Fe - San Lorenzo', value: 'Santa Fe - San Lorenzo' },
    { label: 'Santa Fe - Venado Tuerto', value: 'Santa Fe - Venado Tuerto' },
    { label: 'Santa Fe - Rafaela', value: 'Santa Fe - Rafaela' },
    { label: 'Santa Fe - Reconquista', value: 'Santa Fe - Reconquista' },
    { label: 'Santa Fe - Esperanza', value: 'Santa Fe - Esperanza' },
    { label: 'Mendoza - Mendoza', value: 'Mendoza - Mendoza' },
    { label: 'Mendoza - San Rafael', value: 'Mendoza - San Rafael' },
    { label: 'Mendoza - San Martín', value: 'Mendoza - San Martín' },
    { label: 'Mendoza - Godoy Cruz', value: 'Mendoza - Godoy Cruz' },
    { label: 'Mendoza - Las Heras', value: 'Mendoza - Las Heras' },
    { label: 'Mendoza - Maipú', value: 'Mendoza - Maipú' },
    { label: 'Tucumán - San Miguel de Tucumán', value: 'Tucumán - San Miguel de Tucumán' },
    { label: 'Tucumán - Yerba Buena', value: 'Tucumán - Yerba Buena' },
    { label: 'Tucumán - Lules', value: 'Tucumán - Lules' },
    { label: 'Tucumán - Famaillá', value: 'Tucumán - Famaillá' },
    { label: 'Tucumán - Monteros', value: 'Tucumán - Monteros' },
    { label: 'Entre Ríos - Paraná', value: 'Entre Ríos - Paraná' },
    { label: 'Entre Ríos - Concordia', value: 'Entre Ríos - Concordia' },
    { label: 'Entre Ríos - Gualeguaychú', value: 'Entre Ríos - Gualeguaychú' },
    { label: 'Entre Ríos - Concepción del Uruguay', value: 'Entre Ríos - Concepción del Uruguay' },
    { label: 'Entre Ríos - Gualeguay', value: 'Entre Ríos - Gualeguay' },
    { label: 'Salta - Salta', value: 'Salta - Salta' },
    { label: 'Salta - San Ramón de la Nueva Orán', value: 'Salta - San Ramón de la Nueva Orán' },
    { label: 'Salta - Tartagal', value: 'Salta - Tartagal' },
    { label: 'Salta - Metán', value: 'Salta - Metán' },
    { label: 'Salta - Rosario de la Frontera', value: 'Salta - Rosario de la Frontera' },
    { label: 'Chaco - Resistencia', value: 'Chaco - Resistencia' },
    { label: 'Chaco - Sáenz Peña', value: 'Chaco - Sáenz Peña' },
    { label: 'Chaco - Villa Ángela', value: 'Chaco - Villa Ángela' },
    { label: 'Chaco - Presidencia Roque Sáenz Peña', value: 'Chaco - Presidencia Roque Sáenz Peña' },
    { label: 'Chaco - Charata', value: 'Chaco - Charata' },
    { label: 'Misiones - Posadas', value: 'Misiones - Posadas' },
    { label: 'Misiones - Oberá', value: 'Misiones - Oberá' },
    { label: 'Misiones - Eldorado', value: 'Misiones - Eldorado' },
    { label: 'Misiones - Puerto Iguazú', value: 'Misiones - Puerto Iguazú' },
    { label: 'Misiones - San Vicente', value: 'Misiones - San Vicente' },
    { label: 'Corrientes - Corrientes', value: 'Corrientes - Corrientes' },
    { label: 'Corrientes - Goya', value: 'Corrientes - Goya' },
    { label: 'Corrientes - Paso de los Libres', value: 'Corrientes - Paso de los Libres' },
    { label: 'Corrientes - Curuzú Cuatiá', value: 'Corrientes - Curuzú Cuatiá' },
    { label: 'Corrientes - Mercedes', value: 'Corrientes - Mercedes' },
    { label: 'Santiago del Estero - Santiago del Estero', value: 'Santiago del Estero - Santiago del Estero' },
    { label: 'Santiago del Estero - La Banda', value: 'Santiago del Estero - La Banda' },
    { label: 'Santiago del Estero - Termas de Río Hondo', value: 'Santiago del Estero - Termas de Río Hondo' },
    { label: 'Santiago del Estero - Frías', value: 'Santiago del Estero - Frías' },
    { label: 'Santiago del Estero - Añatuya', value: 'Santiago del Estero - Añatuya' },
    { label: 'San Juan - San Juan', value: 'San Juan - San Juan' },
    { label: 'San Juan - Chimbas', value: 'San Juan - Chimbas' },
    { label: 'San Juan - Santa Lucía', value: 'San Juan - Santa Lucía' },
    { label: 'San Juan - Rawson', value: 'San Juan - Rawson' },
    { label: 'San Juan - Rivadavia', value: 'San Juan - Rivadavia' },
    { label: 'Jujuy - San Salvador de Jujuy', value: 'Jujuy - San Salvador de Jujuy' },
    { label: 'Jujuy - San Pedro de Jujuy', value: 'Jujuy - San Pedro de Jujuy' },
    { label: 'Jujuy - Libertador General San Martín', value: 'Jujuy - Libertador General San Martín' },
    { label: 'Jujuy - Palpalá', value: 'Jujuy - Palpalá' },
    { label: 'Jujuy - Perico', value: 'Jujuy - Perico' },
    { label: 'Río Negro - Viedma', value: 'Río Negro - Viedma' },
    { label: 'Río Negro - General Roca', value: 'Río Negro - General Roca' },
    { label: 'Río Negro - Cipolletti', value: 'Río Negro - Cipolletti' },
    { label: 'Río Negro - San Carlos de Bariloche', value: 'Río Negro - San Carlos de Bariloche' },
    { label: 'Río Negro - Allen', value: 'Río Negro - Allen' },
    { label: 'Neuquén - Neuquén', value: 'Neuquén - Neuquén' },
    { label: 'Neuquén - Cutral Co', value: 'Neuquén - Cutral Co' },
    { label: 'Neuquén - Plottier', value: 'Neuquén - Plottier' },
    { label: 'Neuquén - Centenario', value: 'Neuquén - Centenario' },
    { label: 'Neuquén - San Martín de los Andes', value: 'Neuquén - San Martín de los Andes' },
    { label: 'Chubut - Rawson', value: 'Chubut - Rawson' },
    { label: 'Chubut - Comodoro Rivadavia', value: 'Chubut - Comodoro Rivadavia' },
    { label: 'Chubut - Trelew', value: 'Chubut - Trelew' },
    { label: 'Chubut - Puerto Madryn', value: 'Chubut - Puerto Madryn' },
    { label: 'Chubut - Esquel', value: 'Chubut - Esquel' },
    { label: 'La Pampa - Santa Rosa', value: 'La Pampa - Santa Rosa' },
    { label: 'La Pampa - General Pico', value: 'La Pampa - General Pico' },
    { label: 'La Pampa - Toay', value: 'La Pampa - Toay' },
    { label: 'La Pampa - Realicó', value: 'La Pampa - Realicó' },
    { label: 'La Pampa - General Acha', value: 'La Pampa - General Acha' },
    { label: 'La Rioja - La Rioja', value: 'La Rioja - La Rioja' },
    { label: 'La Rioja - Chilecito', value: 'La Rioja - Chilecito' },
    { label: 'La Rioja - Aimogasta', value: 'La Rioja - Aimogasta' },
    { label: 'La Rioja - Chamical', value: 'La Rioja - Chamical' },
    { label: 'La Rioja - Chepes', value: 'La Rioja - Chepes' },
    { label: 'Catamarca - San Fernando del Valle de Catamarca', value: 'Catamarca - San Fernando del Valle de Catamarca' },
    { label: 'Catamarca - Valle Viejo', value: 'Catamarca - Valle Viejo' },
    { label: 'Catamarca - Fray Mamerto Esquiú', value: 'Catamarca - Fray Mamerto Esquiú' },
    { label: 'Catamarca - Capayán', value: 'Catamarca - Capayán' },
    { label: 'Formosa - Formosa', value: 'Formosa - Formosa' },
    { label: 'Formosa - Clorinda', value: 'Formosa - Clorinda' },
    { label: 'Formosa - Pirané', value: 'Formosa - Pirané' },
    { label: 'Formosa - El Colorado', value: 'Formosa - El Colorado' },
    { label: 'Formosa - Laguna Blanca', value: 'Formosa - Laguna Blanca' },
    { label: 'San Luis - San Luis', value: 'San Luis - San Luis' },
    { label: 'San Luis - Villa Mercedes', value: 'San Luis - Villa Mercedes' },
    { label: 'San Luis - Merlo', value: 'San Luis - Merlo' },
    { label: 'San Luis - La Punta', value: 'San Luis - La Punta' },
    { label: 'San Luis - Concarán', value: 'San Luis - Concarán' },
    { label: 'Tierra del Fuego - Ushuaia', value: 'Tierra del Fuego - Ushuaia' },
    { label: 'Tierra del Fuego - Río Grande', value: 'Tierra del Fuego - Río Grande' },
    { label: 'Tierra del Fuego - Tolhuin', value: 'Tierra del Fuego - Tolhuin' },
    { label: 'Santa Cruz - Río Gallegos', value: 'Santa Cruz - Río Gallegos' },
    { label: 'Santa Cruz - Caleta Olivia', value: 'Santa Cruz - Caleta Olivia' },
    { label: 'Santa Cruz - Río Turbio', value: 'Santa Cruz - Río Turbio' },
    { label: 'Santa Cruz - El Calafate', value: 'Santa Cruz - El Calafate' },
    { label: 'Santa Cruz - Puerto Deseado', value: 'Santa Cruz - Puerto Deseado' }
];
